module.exports = __webpack_public_path__ + "static/img/snail.bda572e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleDan/snail.png
// module id = vgov
// module chunks = 1